/**
 * AUD-020 — constrain user/query-derived redirect destinations to
 * same-origin internal paths.
 *
 * Accepts exactly one leading slash; rejects protocol-relative (`//`),
 * backslashes, absolute URLs/schemes and (repeatedly) percent-encoded
 * variants of those. Anything unsafe returns the trusted `fallback`.
 */
export function safeInternalPath(value: unknown, fallback: string): string {
  if (typeof value !== 'string' || value.length === 0) return fallback;
  if (!value.startsWith('/') || value.startsWith('//')) return fallback;

  // Normalize repeated percent-encoding so "/%2f%2f" and "/%252f%252f"
  // can't smuggle a protocol-relative URL past the checks above.
  let decoded = value;
  for (let i = 0; i < 3; i += 1) {
    let next: string;
    try {
      next = decodeURIComponent(decoded);
    } catch {
      return fallback;
    }
    if (next === decoded) break;
    decoded = next;
  }

  if (decoded.startsWith('//') || decoded.includes('\\')) return fallback;
  return value;
}
